import { devSetting, debuggerMode } from "../setting";
import Vue from 'vue';
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';
import env from '@tencent/vft-common/env';
var sentry = devSetting.sentry;
export function setup() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$use = _ref.use,
      use = _ref$use === void 0 ? true : _ref$use;

  if (process.env.NODE_ENV === 'production' && use) {
    Raven.config(sentry.上报Url, {
      debug: debuggerMode,
      // release: '1',
      ignoreErrors: ['WebViewJavascriptBridge', 'WeixinJSBridge is not defined', /Script error.*/].concat(sentry.忽略错误),
      sampleRate: sentry.采样率 // 采样率

    }).addPlugin(RavenVue, Vue).install().setExtraContext({
      env: "".concat(env.device, ".").concat(env.app)
    });
  }
}